import { render, staticRenderFns } from "./StripeReturn.vue?vue&type=template&id=50e25d72"
import script from "./StripeReturn.vue?vue&type=script&lang=js"
export * from "./StripeReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports